// extracted by mini-css-extract-plugin
export default {"background":"modal_background__8i6zX","dialog":"modal_dialog__8muCM","dialog__header":"modal_dialog__header__8txK1","closeBtn":"modal_closeBtn__GA91W","title":"modal_title__gpKZB"};